import { MouseEvent } from 'react';
import { Button } from '../Button/Button';

type Props = {
  clickHandler: (e: MouseEvent<HTMLElement>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  disabledTooltip?: string;
};

const EmailMeButton = ({
  clickHandler,
  isDisabled,
  isLoading,
  disabledTooltip,
}: Props) => {
  return (
    <Button
      text="Email me!"
      clickHandler={clickHandler}
      type="secondary"
      size="small"
      className="mr-2"
      isDisabled={isDisabled}
      isLoading={isLoading}
      disabledTooltip={disabledTooltip}
    />
  );
};

export { EmailMeButton };
